import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SER_BASIC_01_Schema } from './SER_BASIC_01_Schema';

/**
 * SER_BASIC_01(평가 상세) 관련 React Query 훅 모음
 */

// 마스터 조회
export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SER_BASIC_01_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasic01R1,
      params
    );
  }, successOptions);
};

// 상세 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SER_BASIC_01_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasic01R2,
      params
    );
  }, successOptions);
};

// 마스터 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows, context = {}) => {
    // 서버는 단건 Info 객체를 받으므로, 첫 행만 전송
    const firstRow = Array.isArray(rows) ? rows?.[0] : rows;
    const payload =
      mapRowsBySchema(
        firstRow ? [firstRow] : [],
        SER_BASIC_01_Schema.mapper.save1,
        context
      )?.[0] ?? {};
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.saveSerBasic01U1,
      payload
    );
  }, options);
};

// 상세 저장
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows, context = {}) => {
    // 서버는 단건 Info 객체를 받음 → rows를 단건 호출로 분할 저장
    const list = Array.isArray(rows) ? rows : rows ? [rows] : [];
    const payloads = mapRowsBySchema(
      list,
      SER_BASIC_01_Schema.mapper.save2,
      context
    );

    const results = [];
    for (let i = 0; i < payloads.length; i++) {
      const res = await apiRequest(
        'post1',
        Global.urls.SeriousAccidentAct.saveSerBasic01U2,
        payloads[i]
      );
      const isSuccess = res?.isSuccess ?? res?.IsSuccess;
      if (isSuccess === false) {
        throw new Error(
          res?.message || res?.Message || '저장 중 오류가 발생했습니다.'
        );
      }
      results.push(res);
    }

    // 호출부에서 기존처럼 res.data를 병합할 수 있도록 통일
    return { severity: 'success', data: results };
  }, options);
};

// 페이지별 점수 저장
export const useSave3 = (options = {}) => {
  return useSaveMutation(async (rows, context = {}) => {
    // 서버는 단건 Info 객체를 받음 → rows를 단건 호출로 분할 저장
    const list = Array.isArray(rows) ? rows : rows ? [rows] : [];
    const payloads = mapRowsBySchema(
      list,
      SER_BASIC_01_Schema.mapper.save3,
      context
    );

    const results = [];
    for (let i = 0; i < payloads.length; i++) {
      const res = await apiRequest(
        'post1',
        Global.urls.SeriousAccidentAct.saveSerBasic01U3,
        payloads[i]
      );
      const isSuccess = res?.isSuccess ?? res?.IsSuccess;
      if (isSuccess === false) {
        throw new Error(
          res?.message || res?.Message || '저장 중 오류가 발생했습니다.'
        );
      }
      results.push(res);
    }

    return { severity: 'success', data: results };
  }, options);
};
